import { Typography } from "@material-ui/core";
import * as React from "react";
import {
  TicketItemProps,
  TicketListItem,
} from "./TicketListItem/TicketListItem";
import { TicketCountIcons } from "./TicketListItem/TicketCountIcons";
import styled from "styled-components";
import NoTicketsImage from "Assets/Images/no-tickets.png";
import { useSelector } from "react-redux";
import { RootStateType } from "State/Store";

const StyleNoTicketsImage = styled.img`
  width: 90%;
  margin-top: -15px;
  margin-left: -10px;
`;

const StyledHeader = styled.div`
  > * {
    float: left;
  }

  h4 {
    margin-right: 15px;
  }

  ::after {
    display: block;
    content: "";
    clear: both;
  }
`;

const StyledNoTicketsText = styled.div`
  width: 90%;
  text-align: center;
  margin-top: 0px;

  h4 {
    font-size: 22px;
    font-weight: 400;
    margin-bottom: 0px;
    margin-top: 0px;
  }

  p {
    margin-top: 5px;
    font-size: 15px;
    font-weight: 400;
    color: #6d7278;
  }
`;

type TicketListProps = {
  tickets: TicketItemProps[];
  title: string;
  maxItems: number;
  onResolveClick: (ticketID: number, groupCode?: string | null) => void;
  onCancelClick: (ticketID: number, groupCode?: string | null) => void;
};

const StyledTitle = styled(Typography)`
  margin-bottom: ${props => props.theme.spacing(3)}px;

  ${props => props.theme.breakpoints.down("xs")} {
    margin-left: ${props => props.theme.spacing(1.3)}px;
  }
`;

export const TicketList: React.FunctionComponent<TicketListProps> = props => {
  const { user } = useSelector((e: RootStateType) => e.auth);
  const isFemale =
    user?.lastName.endsWith("ova") === true ||
    user?.lastName.endsWith("vska") === true;

  const count =
    props.tickets && props.tickets.length > 0
      ? props.tickets
          .map(e => e.ticketsInGroupCount || 1)
          .reduce((a, b) => a + b)
      : 0;
  const afterDueDateCount =
    props.tickets && props.tickets.length > 0
      ? props.tickets
          .map(e => e.ticketsAfterDueDateCount)
          .reduce((a, b) => a + b)
      : 0;

  return (
    <div>
      <StyledHeader>
        <StyledTitle variant="h4">{props.title} </StyledTitle>
        <TicketCountIcons
          ticketsAfterDueDateCount={afterDueDateCount}
          ticketsCount={count}
        ></TicketCountIcons>
        <div className="clearfix"></div>
      </StyledHeader>
      {props.tickets.length === 0 ? (
        <>
          <StyleNoTicketsImage src={NoTicketsImage} alt="no-tickets.png" />
          <StyledNoTicketsText>
            <h4>Skvělé, všechny resty máš vyřešené!</h4>
            <p>
              Vyřešil{isFemale ? "a" : ""} jsi všechna upozornění, tak to má
              být,<br></br> tak je to správné :)
            </p>
          </StyledNoTicketsText>
        </>
      ) : (
        <div>
          {props.tickets
            .filter((_, index) => index < props.maxItems)
            .map(e => (
              <TicketListItem
                key={e.ticketID}
                item={e}
                onResolveClick={props.onResolveClick}
                onCancelClick={props.onCancelClick}
              />
            ))}
        </div>
      )}
    </div>
  );
};
